const state = {
    professionalValues: [
        // {
        //     title: ''
        //     stimuliToBeMeasured: '',
        //     stimulusDescription: '',
        //     status: ''
        // },
    ],
};

const mutations = {
    setProfessionalValues(state, value) {
        state.professionalValues = value;
    },
};

const actions = {
    updateProfessionalValues({ commit }, value) {
        commit('setProfessionalValues', value);
    },
};

const getters = {
    professionalValues: state => state.professionalValues,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
